export default __webpack_public_path__ + "static/media/arrow_back_ios_black_24dp.51a52cad.svg";